import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import Footer from "./Footer";
import background from "../../assets/LandingPage/Background (1).png";
import TermsOfUse from "../Legal/TermsOfUse";
import PrivacyPolicy from "../Legal/PrivacyPolicy";
import CCPAPolicy from "../Legal/CCPAPolicy";
import Header from "./Header";

const NewLegalPage = () => {
  const { page } = useParams();
  const navigate = useNavigate();
  console.log(page)


  const normalizedPage =
    page === "terms-of-use"
      ? "Terms and Conditions"
      : page === "privacy-policy"
      ? "Privacy Policy"
      : page === "ccpa-policy"
      ? "CCPA Policy"
      : "";

  const handleRedirect = (selectedPage) => {
    navigate(
      `/legal/${
        selectedPage === "Terms and Conditions"
          ? "terms-of-use"
          : selectedPage === "Privacy Policy"
          ? "privacy-policy"
          : selectedPage === "CCPA Policy"
          ? "ccpa-policy"
          : "Privacy Policy"
      }`
    );
  };

  return (
    <div style={{ display: "flex", flexDirection: "column" }}>
      <Header/>
      <div className="flex flex-grow justify-center items-center h-[495px] bg-[#eaf524]">
        <h1
          className="text-black text-center text-ellipsis font-[700] text-[50px] sm:text-[80px]
        md:text-[100px]"
        >
          {normalizedPage}
        </h1>
      </div>

      <div className="flex flex-col md:flex-row gap-12 md:gap-32 text-left pt-20 pb-20">
        <div className="flex flex-col whitespace-nowrap pl-[62px] gap-5 text-xl text-[#515151]">
          <span
            onClick={() => handleRedirect("Terms and Conditions")}
            className={`${
              normalizedPage === "Terms and Conditions"
                ? "text-[#0088ff]"
                : "text-[#515151]"
            } cursor-pointer`}
          >
            Terms and Conditions
          </span>
          <span
            onClick={() => handleRedirect("Privacy Policy")}
            className={`${
              normalizedPage === "Privacy Policy"
                ? "text-[#0088ff]"
                : "text-[#515151]"
            } cursor-pointer`}
          >
            Privacy Policy
          </span>
          <span
            onClick={() => handleRedirect("CCPA Policy")}
            className={`${
              normalizedPage === "CCPA Policy"
                ? "text-[#0088ff]"
                : "text-[#515151]"
            } cursor-pointer`}
          >
            CCPA Policy
          </span>
        </div>

        {normalizedPage === "Terms and Conditions" && <TermsOfUse />}
        {normalizedPage === "Privacy Policy" && <PrivacyPolicy />}
        {normalizedPage === "CCPA Policy" && <CCPAPolicy />}
      </div>

      <Footer/>
    </div>
  );
};

export default NewLegalPage;
